import { format } from 'date-fns';
import { DATE_FORMAT } from './constants';

export const formatDate = (
  time: string,
  dateFormat = DATE_FORMAT.TIME_AND_DATE,
) => format(new Date(time), dateFormat);
